import type { MessageKey } from 'types/LocaleMessageKey';

interface HighlightedFeatureData {
  id: number;
  text: MessageKey;
  image: {
    src: string;
    alt: MessageKey;
  };
}

export const membershipHighlightedFeaturesJadeData: HighlightedFeatureData[] = [
  {
    id: 1,
    text: 'membership_features_highlight_sleep_analysis',
    image: {
      src: 'membership/jade/feature-01',
      alt: 'experience_style_image_1_alt',
    },
  },
  {
    id: 2,
    text: 'membership_features_highlight_health_insights',
    image: {
      src: 'membership/jade/feature-02',
      alt: 'membership_jade_feature_02_alt',
    },
  },
  {
    id: 3,
    text: 'membership_features_highlight_heart_rate_monitoring',
    image: {
      src: 'membership/jade/feature-03',
      alt: 'explore_image_alt_1',
    },
  },
  {
    id: 4,
    text: 'membership_features_highlight_body_temp',
    image: {
      src: 'membership/jade/feature-04',
      alt: 'membership_jade_feature_04_alt',
    },
  },
];
